module.exports = __webpack_public_path__ + "static/media/default-logo.666e615d.png";